<template>
  <div id="app">
    <ContentBox>
      <router-view></router-view>
    </ContentBox>
    <Footer></Footer>
  </div>
</template>

<script>
import ContentBox from "./components/ContentBox";
import Footer from "./components/Footer";
export default {
  components: {
    Footer,
    ContentBox
  },
  data() {
    return {};
  }
};
</script>

<style>
#app {
  background: #f5f6f8;
}
input {
  outline-color: none;
  outline-style: none;
  outline-width: none;
}
</style>
